var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { getPrepopulateData } from '../services/SprinklerSamplingService';
import { sprinklerSamplingKeys } from './queryKeys';
export function usePrepopulateQuery(buildingId) {
    return useQuery({
        queryKey: sprinklerSamplingKeys.prepopulate(buildingId),
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const response = yield getPrepopulateData(buildingId);
            if (response.error) {
                throw new Error(response.error.message);
            }
            return response.data;
        }),
        enabled: !!buildingId,
        staleTime: 10 * 60 * 1000, // 10 minutes - form defaults don't change often
        cacheTime: 30 * 60 * 1000 // 30 minutes
    });
}
